import React from 'react';
import { ABOUT_FEATURES } from '../data/mockData';
import { ArrowRight, CheckCircle } from 'lucide-react';

const AboutUs = ({ onEnquireClick }) => {
  return (
    <section id="about" className="py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-2 text-xs font-semibold tracking-[0.2em] text-[#DAA520] border border-[#DAA520]/30 rounded-sm mb-6">
              ABOUT US
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3">
              Redefining Luxury Real Estate in <span className="text-[#DAA520] italic">Bangalore</span>
            </h2>
            <div className="w-12 h-0.5 bg-[#DAA520] mb-6" />
            <p className="text-gray-400 text-lg leading-relaxed mb-8">
              At Livelong Wealth, we combine deep market knowledge with personal attention to help
              you find properties that match your lifestyle. Our dedication to excellence and
              client-first approach has earned us the trust of over 1,200 happy homeowners.
            </p>

            {/* Features */}
            <div className="space-y-6 mb-10">
              {ABOUT_FEATURES.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#DAA520]/10 flex items-center justify-center mt-0.5">
                    <CheckCircle size={18} className="text-[#DAA520]" />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">{feature.title}</h4>
                    <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={onEnquireClick}
              className="group inline-flex items-center gap-2 px-8 py-4 bg-[#DAA520] text-black font-semibold tracking-wider text-sm rounded-sm hover:bg-[#C49B17] transition-all duration-300"
            >
              CONNECT WITH US
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=700&h=500&fit=crop"
                alt="Luxury Interior"
                className="w-full h-[500px] object-cover rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -left-6 bg-[#1a1a1a] border border-[#DAA520]/20 rounded-lg p-6 shadow-2xl">
              <div className="text-3xl font-bold text-[#DAA520] mb-1">10+</div>
              <div className="text-gray-400 text-sm">Years of Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
